import { Injectable } from '@angular/core';
import { ComponentFactoryResolver, Injector, ApplicationRef, ComponentRef } from '@angular/core';
import { DialogComponent } from './dialog.component';
import { ConfirmDialogData } from './dialog.data';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
  ) {}

  open(options: ConfirmDialogData) {
    const dialogComponentRef = this.createDialogComponent();
    dialogComponentRef.instance.data = options;

    dialogComponentRef.instance.closeDialog.subscribe(() => {
      this.close(dialogComponentRef);
    });

    dialogComponentRef.instance.confirm.subscribe((value: string) => {
      options.confirmFunction(value);
      this.close(dialogComponentRef);
    });
  }

  private createDialogComponent(): ComponentRef<DialogComponent> {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(DialogComponent);
    const componentRef = componentFactory.create(this.injector);
    this.appRef.attachView(componentRef.hostView);

    document.body.appendChild(componentRef.location.nativeElement);
    return componentRef;
  }

  close(componentRef: ComponentRef<DialogComponent>) {
    this.appRef.detachView(componentRef.hostView);
    componentRef.destroy();
  }
}
